<template>
  <custom-dialog
    class="portal-add-bill-dialog"
    :title="model.title"
    width="1400px"
    :visible="visible"
    v-on="$listeners"
  >
    <div class="dialog-body">
      <div class="query-filter">
        <div class="params-form">
          <el-row :gutter="23">
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('add_bill_dialog.fkdqsj') }}</div>
                <div class="value">
                  <custom-date-picker
                    v-model="formSearch.billPaymentTime"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="—"
                    :start-placeholder="$t('add_bill_dialog.kai_shi_shi_jian')"
                    :end-placeholder="$t('add_bill_dialog.jie_shu_shi_jian')"
                    @change="onDateChange"
                    value-format="YYYY-MM-DD HH:mm:ss"
                  ></custom-date-picker>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('Common.com_location') }}</div>
                <div class="value">
                  <el-input
                    v-model="formSearch.locationName"
                    @input="onLocationChange"
                    clearable
                    :placeholder="$t('Common.com_please_input')"
                  ></el-input>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                <div class="label">{{ $t('add_bill_dialog.shou_kuan_gong_si') }}</div>
                <div class="value">
                  <el-input
                    v-model="formSearch.receivableOrgName"
                    @input="onCompanyChange"
                    clearable
                    :placeholder="$t('Common.com_please_input')"
                  ></el-input>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="filter-values">
          <div class="label">{{ $t('Common.com_filter_item') }}</div>
          <div class="values">
            <el-tag
              closable
              v-for="dateTag in dateTagList"
              :key="dateTag.value"
              @close="onCloseTime(dateTag.value)"
            >{{dateTag.label}}</el-tag>
            <el-tag
              closable
              v-for="locationNameTag in locationNameTagList"
              :key="locationNameTag.value"
              @close="onCloseLocationName(locationNameTag.value)"
            >{{locationNameTag.label}}</el-tag>
            <el-tag
              closable
              v-for="companyTag in companyTagList"
              :key="companyTag.value"
              @close="onCloseCompanyName(companyTag.value)"
            >{{companyTag.label}}</el-tag>
            <el-button
              type="info"
              size="mini"
              @click="onClear"
            >{{ $t('Common.com_clear') }}</el-button>
          </div>
        </div>
      </div>
      <div class="table-content">
        <div class="header">
          <div class="label">{{ $t('add_bill_dialog.zhang_dan_lie_biao') }}</div>
          <div class="search-content">
            <el-form
              :inline="true"
              @submit.native.prevent
            >
              <el-form-item style="float: right; margin-right: 0">
                <custom-column ref="column"></custom-column>
              </el-form-item>
              <el-form-item style="float:right; margin-right:  16px;">
                <search-input
                  v-model="formSearch.keyword"
                  :placeholder="$t('add_bill_dialog.htbhjsh')"
                  @fetch="onPageChange({page:1})"
                ></search-input>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div class="table-bd">
          <custom-table
            tableCode="portal_add_bill_list"
            height="100%"
            :stripe="true"
            :data="tableList"
            v-model="selectedData"
            type="checkbox"
            @column="setColumn"
            columnRef="column"
            @filter="filterChange"
            @sort="sortChange"
            selectableKey="disabled"
            :slots="['isDelay']"
          >
            <template v-slot:isDelay="scope">
              {{getUrgentView(scope.row)}}
            </template>
          </custom-table>
        </div>
        <div class="page-footer">
          <custom-pagination
            :total="totalRows"
            :page="formSearch.pageNum"
            :size="formSearch.pageSize"
            @change="onPageChange"
            radius
          ></custom-pagination>
        </div>
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="info"
        plain
        @click="closeDialog"
      >{{ $t('Common.com_cancel') }}</el-button>
      <el-button
        type="warning"
        @click="onConfirm"
      >{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
// 新增账单
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';
import mixins from './mixins';

export default {
  mixins: [dialogMixins, mixins],
  props: {
    filterBillIdList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  components: {
  },
  computed: {
  },
  data() {
    return {
      billType: '',
      formSearch: {
        keyword: '',
        pageSize: 50,
        pageNum: 1,
        billPaymentTime: '',
        locationName: '',
        receivableOrgName: '',
        paymentOrReceivable: true,
        payableOrgId: '',
        receivableOrgId: '',
      },
      totalRows: 0,
      tableList: [
      ],
      selectedData: [],
      dateTagList: [],
      locationNameTagList: [],
      companyTagList: [],


    };
  },
  methods: {
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.closeDialog();
      this.$emit('confirm', this.selectedData);
    },
    onLocationChange() {
      const locationName = this.formSearch.locationName.trim();
      if (locationName) {
        this.locationNameTagList = [
          {
            label: locationName,
            value: 'company'
          }
        ];
      } else {
        this.locationNameTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseLocationName() {
      this.formSearch.locationName = '';
      this.onLocationChange();
    },
    onCompanyChange() {
      const receivableOrgName = this.formSearch.receivableOrgName.trim();
      if (receivableOrgName) {
        this.companyTagList = [
          {
            label: receivableOrgName,
            value: 'receivableOrgName'
          }
        ];
      } else {
        this.companyTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseCompanyName() {
      this.formSearch.receivableOrgName = '';
      this.onCompanyChange();
    },
    onClear() {
      this.dateTagList = [];
      this.locationNameTagList = [];
      this.companyTagList = [];
      this.formSearch.billPaymentTime = '';
      this.formSearch.locationName = '';
      this.formSearch.receivableOrgName = '';
      this.onPageChange({ page: 1 });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    onDateChange() {
      const data = this.formSearch.billPaymentTime;
      if (data && data.length) {
        const start = this.$momentLocal(data[0], 'YYYY-MM-DD');
        const end = this.$momentLocal(data[1], 'YYYY-MM-DD');
        this.dateTagList = [
          {
            label: `${start}-${end}`,
            value: 'date'
          }
        ];
      } else {
        this.dateTagList = [];
      }
      this.onPageChange({ page: 1 });
    },
    onCloseTime() {
      this.formSearch.billPaymentTime = [];
      this.onDateChange();
    },
    getReqData() {
      const reqData = { ...this.formSearch, filterBillIdList: this.filterBillIdList };
      if (!this.formSearch.billPaymentTime || !this.formSearch.billPaymentTime.length) {
        delete reqData.billPaymentTime;
      }
      return reqData;
    },
    getTableList() {
      const reqUrl = apis.paymentToAddPayablePage;
      const reqData = this.getReqData();
      this.$getJSON(reqUrl, reqData).then((res) => {
        this.tableList = this.formatRefundBill(res.data.records);
        this.totalRows = res.data.total;
      });
    },
  },
  mounted() {
    // this.getLanguage();
    this.billType = this.model.data.billType;
    this.formSearch.receivableOrgId = this.model.data.receivableOrgId;
    this.formSearch.payableOrgId = this.model.data.payableOrgId;
    this.getTableList();
  },
};
</script>

<style lang="scss">
.portal-add-bill-dialog {
  .custom-pagination {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;
  }
  .query-filter {
    padding-top: 0;
  }
  .table-content {
    border-radius: 16px;
    background: #fff;
    > .header {
      padding: 0 24px;
      .label {
        color: #1a1a1a;
        line-height: 40px;
        font-weight: bold;
        float: left;
      }
      .search-content {
        float: right;
      }
    }

    .table-bd {
      height: 416px;
      width: 100%;
      overflow: hidden;
      padding: 0 24px;
      margin-top: 24px;
    }

    // .page-footer {
    //   height: 88px;
    // }
  }
}
</style>
